<div *ngIf="!showEnterOtp" class="flex justify-center items-center w-full h-full font-poppins animate-slideIn">
    <div class="flex justify-center items-center w-full h-full">
        <svg xmlns="http://www.w3.org/2000/svg" width="321" height="317" viewBox="0 0 321 317" fill="none"
            class="opacity-80 z-10">
            <path d="M320 1H1V316H5.20844H187.855L320 171.816V1Z" fill="url(#paint0_linear_1_13)" fill-opacity="1"
                stroke="white" />
            <defs>
                <linearGradient id="paint0_linear_1_13" x1="160.5" y1="64.7975" x2="160.5" y2="316"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1D2555" />
                    <stop offset="1" stop-color="#05050C" />
                </linearGradient>
            </defs>
        </svg>
        <div class="absolute top-[30%] z-20 flex justify-center items-center w-full">
            <form class="flex flex-col justify-center items-center" (ngSubmit)="forgotPassword()">
                <input type="text" [(ngModel)]="email" name="email" placeholder="Enter email here" class="bg-transparent text-white border-b-2 border-white p-1 mb-2 w-[250px] outline-none">
                <button type="submit" class="relative mt-2 h-[50px] w-[250px] bg-[#31A1F6] text-white transform -translate-x-[45px] translate-y-[70px] hover:text-[#31A1F6] overflow-hidden group">
                    <span class="relative z-10">Send OTP</span>
                    <span class="absolute inset-0 w-0 h-full bg-white transition-all duration-300 ease-in-out group-hover:w-full"></span>
                </button>
            </form>
        </div>
    </div>
</div>

<div *ngIf="showEnterOtp" class="enter-otp-container">
    <app-enter-otp [isForgotPasswordComponent]="true" [email]="this.email"></app-enter-otp>
</div>
